export default __webpack_public_path__ + "static/media/south.86855f1e.png";